/* ITEM 5 — Shopify Forms 15% modal close-on-first-click + hide extra Forms overlays.
   Forms render in an open shadow root. Theme CSS cannot style the X.
   Escape already closed the modal; the X is a 12px span and often missed.
*/
(function () {
  var KEEP = /15\s*%|one-time purchase/i;
  var HIDE = /join the club|get 10%\s*off your first order/i;
  var CLOSE_CSS =
    '[aria-label="Close modal"]{' +
      'display:inline-flex!important;' +
      'align-items:center!important;' +
      'justify-content:center!important;' +
      'min-width:44px!important;' +
      'min-height:44px!important;' +
      'padding:14px!important;' +
      'box-sizing:border-box!important;' +
      'cursor:pointer!important;' +
      'z-index:2147483647!important;' +
      'position:relative!important;' +
      'pointer-events:auto!important;' +
      'margin:-8px -8px 0 0!important;' +
    '}' +
    '[aria-label="Close modal"] svg{pointer-events:none!important;width:14px;height:14px;}';

  function isCloseNode(n) {
    if (!n || !n.getAttribute) return false;
    var label = (n.getAttribute('aria-label') || '').toLowerCase();
    if (label === 'close modal' || label === 'close') return true;
    var cls = String(n.className || '');
    return cls.indexOf('_formCloseButton_') !== -1;
  }

  function inject(root) {
    if (!root || root.querySelector('style[data-kt-item5]')) return;
    var style = document.createElement('style');
    style.setAttribute('data-kt-item5', '1');
    style.textContent = CLOSE_CSS;
    root.appendChild(style);
  }

  function maybeHide(host) {
    var root = host.shadowRoot;
    if (!root) return;
    var text = (root.textContent || '').replace(/\s+/g, ' ');
    if (KEEP.test(text)) return;
    if (HIDE.test(text)) {
      host.style.setProperty('display', 'none', 'important');
      var wrap = host.closest('[id^="app-embed-container-"]');
      if (wrap) wrap.style.setProperty('display', 'none', 'important');
    }
  }

  function enhance(host) {
    if (!host.shadowRoot) return;
    inject(host.shadowRoot);
    maybeHide(host);
  }

  function scan() {
    document.querySelectorAll('shopify-forms-embed').forEach(enhance);
  }

  /* First pointer on the X also sends Escape, which Forms already handles. */
  document.addEventListener(
    'pointerdown',
    function (e) {
      var path = e.composedPath ? e.composedPath() : [];
      var closeEl = null;
      for (var i = 0; i < path.length; i++) {
        if (isCloseNode(path[i])) {
          closeEl = path[i];
          break;
        }
      }
      if (!closeEl) return;
      try {
        closeEl.dispatchEvent(
          new MouseEvent('click', { bubbles: true, cancelable: true, composed: true })
        );
      } catch (err) {}
      try {
        document.dispatchEvent(
          new KeyboardEvent('keydown', {
            key: 'Escape',
            code: 'Escape',
            keyCode: 27,
            which: 27,
            bubbles: true,
            cancelable: true,
          })
        );
      } catch (err2) {}
    },
    true
  );

  var mo = new MutationObserver(scan);
  mo.observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  var n = 0;
  var tick = setInterval(function () {
    scan();
    n += 1;
    if (n > 20) clearInterval(tick);
  }, 500);
})();
